'use client';

import React from 'react';

import clsx from 'clsx';

import styles from './styles.module.css';

import { VisibleSearchBar } from '@/components/VisibleSearchBar';
import { useShowHomepageSearchBar } from '@/modules/home/hooks/useShowHomepageSearchBar';
import { useOnScrollUp } from '@/utils/useOnScrollUp';

export function HomepageSearchBar() {
  const { visibleSearchBar: isVisible, stickySearchbar: isSticky } =
    useShowHomepageSearchBar();
  const { hasScrolledUp } = useOnScrollUp();

  const searchBarIsSticky = isSticky && hasScrolledUp;

  if (!isVisible) {
    return null;
  }

  return (
    <>
      <VisibleSearchBar
        className={clsx(styles.searchBarWrapper, {
          [styles.stickyMobileSearchBar]: searchBarIsSticky,
        })}
      />
      {searchBarIsSticky && <div className={styles.placeholder} />}
    </>
  );
}
